angular.module("FlexyBeautyApp").constant("Constants", {
    "themes": {
        "pink": "theme-pink",
        "pink-original": "theme-pink",
        "pinkcontrast": "theme-pinkcontrast",
        "blue": "theme-blue",
        "night": "theme-night",
        "green": "theme-green",
        "red": "theme-red"
    },
    "defaultTheme": "blue",
    "EMAIL": "^([a-zA-Z0-9_-]+(?:\\.[a-zA-Z0-9_-]+)*)@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$",
    "ngRoutings": {
        "customer": {
            "list": "customer",
            "smsmarketing": "customer/smsmarketing",
            "notification": "customer/notification",
            "trash": "customer/trash",
            "config": "customer/config"
        }
    },
    'WEBSITE_PATH_BY_STORE_APP_CODE' : {
        'cure' : ['cure', 'cureCategory'],
        'loyaltyCard' : ['loyaltyCardCategory', 'loyaltyCard'],
        'giftItem' : ['giftItem', 'giftItems', 'giftItemsMail']
    },
    "DEFAULT_CURRENCY_CODE": "EUR",
    "DEFAULT_LOCALE_CODE": "fr-FR",
    'APP_DOMAIN' : {
        "planningPos" : "planningPos",
        "statistics" : "statistics",
        "site" : "site",
        "flexyBeauty" : "flexyBeauty"

    },
    "APP_SUB_DOMAIN" : {
        "pos" : "pos",
        "planning" : "planning",
        "flexyStore" : "flexyStore",
        "paymentMode" : "paymentMode"
    },
    "KIUTE_PRO_APP": {
        "local": 'http://localhost:3000',
        "staging": "https://kiute-pro-staging.kiute.com",
        "prod": "https://kiute-pro-prod.kiute.com",
    },
    "BUGSNAG_WARN_LEVEL" : "warning",
    "BUGSNAG_NOTIFICATION_LEVEL" : "info",
    "SMS_REMINDER_HOURS_TO_SEND":  [{hourNumber: 8, hour: '8H00'}, {hourNumber:9, hour: '9H00'}, {hourNumber:10, hour:'10H00'}, {hourNumber:11, hour: '11H00'},
                                    {hourNumber: 12, hour: '12H00'}, {hourNumber:13, hour: '13H00'}, {hourNumber: 14, hour: '14H00'},
                                    {hourNumber: 15, hour: '15H00'}, {hourNumber: 16, hour: '16H00'}, {hourNumber: 17, hour: '17H00'},
                                    {hourNumber: 18, hour: '18H00'}, {hourNumber: 19, hour: '19H00'}, {hourNumber: 20, hour: '20H00'}],
    "MAX_SERVICES_FOR_COMPANY": 1000,
    "ANGULAR_TABS" : {
        "LOYALTY_CARD_ITEMS": "loyaltyCardItems",
        "GIFT_ITEMS": "giftItems",
        "CURE_ITEMS": "cureItems"
    },
    "ANGULAR_EVENTS" : {
        "REFRESH": "refresh",
        "MANAGER_MODE": "managerMode"
    },
    "EXPORT_FORMAT" : {
        "CSV": {
            name : "CSV",
            hrefAttachment: "data:attachment/csv;charset=utf-8",
            fileExtension: "csv"
        },
        'XLSX': {
            name: 'XLSX',
            hrefAttachment: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8',
            fileExtension: 'xlsx'
        }
    },
    'SITE_COUNTRIES': [{
        code: 'FR',
        name: 'France',
        timezone: 'Europe/Paris'
      }, {
        code: 'GP',
        name: 'Guadeloupe',
        timezone: 'America/Guadeloupe'
      }, {
        code: 'MQ',
        name: 'Martinique',
        timezone: 'America/Martinique'
      }, {
        code: 'GF',
        name: 'Guyane',
        timezone: 'America/Cayenne'
      }, {
        code: 'RE',
        name: 'La Réunion',
        timezone: 'Indian/Reunion'
      }, {
        code: 'BE',
        name: 'Belgique',
        timezone: 'Europe/Brussels'
      }, {
        code: 'CH',
        name: 'Suisse',
        timezone: 'Europe/Zurich'
    }],
    "WEBSITE_USELESS_THEME_LABELS": ['Pastel', 'Black Bird', 'Noël étoilé'],
    "SECONDS_IN_A_DAY": 86400000,
    "NB_STARTUP_LOADED_DAYS": 7,
    "CATEGORY_LABELS" : {
        "YOUR_SERVICES" : "Vos prestations",
        "YOU_OTHER_SERVICES" : "Vos autres prestations"
    },
    "USER_ACTION_DATE_INTERVAL_NORMAL_ACTIVITY_IN_MILLI_SECONDS": 120000,
    "USER_ACTION_DATE_INTERVAL_LOW_ACTIVITY_IN_MILLI_SECONDS": 1800000 /* 3O minutes */,
    "IDLE_TIME_START_IN_SECONDS": 1800 /* 3O minutes */
});



// WEBPACK FOOTER //
// ./js/constants/constant.js